import { type AvatarSizeMap } from './types';

export const AVATAR_SIZES: AvatarSizeMap = {
	xsmall: 16,
	UNSAFE_xsmall: 20,
	small: 24,
	medium: 32,
	large: 40,
	xlarge: 96,
	xxlarge: 128,
};
